import React from 'react';
import { StyledH3 } from './index.styled';
import { withTranslationText } from '../../hoc/withTranslationText';

export const H3 = withTranslationText(({ renderText, children, ...props }) => (
    <StyledH3 {...props}>{renderText ? renderText : children}</StyledH3>
));
